import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../SideBarUserManagement'
import { InputDate } from '../common/InputDate'
import {
  selectOrderStatus,
  selectTransactionStatus,
} from '../orderManagement/store/slice'
import { getTransactionStatusAndOrderStatusThunk } from '../orderManagement/store/thunk'
import { ALL_STATUS, REQUEST_TYPE_FILTER } from './constants'
import './i18n'
import {
  changeFilter,
  selectFilterByKey,
  selectSubscriptionAndPackageTypes,
} from './store/slice'
import { getSubscriptionAndPackageOrdersTypes } from './store/thunk'

export const FilterList = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getTransactionStatusAndOrderStatusThunk())
    dispatch(getSubscriptionAndPackageOrdersTypes())
  }, [])

  return (
    <div
      className="dFlex flexWrap"
      style={{ padding: 12, paddingBottom: 0, gap: '12px 30px' }}
    >
      <RequestType />
      <Type />
      <RequestStatus />
      <PaymentStatus />
      <DateRequested />
      <div />
    </div>
  )
}

const Type = () => {
  const dispatch = useDispatch()

  const allTypes = useSelector(selectSubscriptionAndPackageTypes)
  const type = useSelector(selectFilterByKey('type'))

  const selectionPackageTypes = [
    ALL_STATUS,
    ...allTypes.map((item) => ({
      ...item,
      label: item.name,
      value: item.id,
      key: item.id,
    })),
  ]

  const changeType = (item) => {
    dispatch(changeFilter({ type: item }))
  }

  return (
    <div className={['flexRow alignItemsCenter'].join(' ')}>
      <Element className="fw600">
        <Translate value="userManagement.packageSubManagement.TYPE" />
      </Element>
      <SelectCustom
        data={selectionPackageTypes}
        chooseItem={changeType}
        style={{
          width: 'fit-content',
          minWidth: 150,
          color: '#3A414B',
          marginLeft: 10,
        }}
        isI18n
        activeItem={type}
        zIndex={14}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}

const RequestType = () => {
  const dispatch = useDispatch()

  const requestType = useSelector(selectFilterByKey('requestType'))

  const changeRequestType = (item) => {
    dispatch(changeFilter({ requestType: item }))
  }

  return (
    <div className="flexRow alignItemsCenter">
      <Element className="fw600" style={{ width: 100 }}>
        <Translate value="userManagement.packageSubManagement.REQUEST_TYPE" />
      </Element>
      <SelectCustom
        data={REQUEST_TYPE_FILTER}
        chooseItem={changeRequestType}
        style={{
          width: 150,
          color: '#3A414B',
          marginLeft: 10,
        }}
        isI18n
        activeItem={requestType}
        zIndex={14}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}

const RequestStatus = () => {
  const dispatch = useDispatch()

  const requestStatusList = useSelector(selectOrderStatus)
  const requestStatus = useSelector(selectFilterByKey('requestStatus'))

  const requestStatusSelection = [
    ALL_STATUS,
    ...requestStatusList.map((item) => ({
      label: `userManagement.orderManagement.${item?.status.toUpperCase()}`,
      value: item.status,
      isI18n: true,
    })),
  ]

  const changeRequestStatus = (item) => {
    dispatch(changeFilter({ requestStatus: item }))
  }

  return (
    <div className={['flexRow alignItemsCenter'].join(' ')}>
      <Element className="fw600">
        <Translate value="userManagement.packageSubManagement.REQUEST_STATUS" />
      </Element>
      <SelectCustom
        data={requestStatusSelection}
        chooseItem={changeRequestStatus}
        style={{
          width: 150,
          color: '#3A414B',
          marginLeft: 10,
        }}
        isI18n
        activeItem={requestStatus}
        zIndex={14}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}

const PaymentStatus = ({ appendStyle }) => {
  const dispatch = useDispatch()

  const paymentStatusList = useSelector(selectTransactionStatus)
  const paymentStatus = useSelector(selectFilterByKey('paymentStatus'))

  const paymentStatusSelection = [
    ALL_STATUS,
    ...paymentStatusList.map((item) => ({
      label: `userManagement.orderManagement.${item?.status.toUpperCase()}`,
      value: item.status,
      isI18n: true,
    })),
  ]

  const changePaymentStatus = (item) => {
    dispatch(changeFilter({ paymentStatus: item }))
  }

  return (
    <div className={['flexRow alignItemsCenter'].join(' ')}>
      <Element className="fw600" style={{ ...appendStyle }}>
        <Translate value="userManagement.packageSubManagement.PAYMENT_STATUS" />
      </Element>
      <SelectCustom
        data={paymentStatusSelection}
        chooseItem={changePaymentStatus}
        style={{
          width: 150,
          color: '#3A414B',
          marginLeft: 10,
        }}
        isI18n
        activeItem={paymentStatus}
        zIndex={14}
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}

const DateRequested = () => {
  const dispatch = useDispatch()

  const from = useSelector(selectFilterByKey('from'))
  const to = useSelector(selectFilterByKey('to'))

  const onFromChange = (from) => {
    dispatch(changeFilter({ from, page: 1 }))
  }

  const onToChange = (to) => {
    dispatch(changeFilter({ to, page: 1 }))
  }

  return (
    <div className={['flexRow alignItemsCenter'].join(' ')}>
      <Element className="fw600">
        <Translate value="userManagement.packageSubManagement.PURCHASE_DATE" />
      </Element>
      <div className="flexRow">
        <InputDate
          defaultDate={from ? from : undefined}
          value={from}
          onChange={onFromChange}
          placeholder={UseI18n('screening.FROM')}
        />
        <InputDate
          defaultDate={to ? to : undefined}
          value={to}
          onChange={onToChange}
          placeholder={UseI18n('screening.TO')}
        />
      </div>
    </div>
  )
}
